module.exports = __webpack_public_path__ + "img/DateTimeRange.6ae414f4.svg";